import { IAppState } from '../common/state';

export function getResultsRoomType({ results: { jsonQuery } }: IAppState) {
  return (jsonQuery.room && jsonQuery.room.value) || [];
}
